import React, { useState, useRef } from "react";

import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap"
import { SelectionMode } from "@fluentui/react/lib/DetailsList";
import { ShimmeredDetailsList } from '@fluentui/react/lib/ShimmeredDetailsList';
import { Selection } from '@fluentui/react/lib/DetailsList';
import { TextField, ThemeProvider } from "@fluentui/react/lib/";
import { DetailsListLayoutMode, ConstrainMode } from '@fluentui/react';
import { Pagination } from '@uifabric/experiments'
import { DetailsHeader } from "@fluentui/react/lib/components/DetailsList/DetailsHeader";
import { Dropdown } from '@fluentui/react/lib/Dropdown';
import { IconButton } from '@fluentui/react/lib/Button';
import { OverflowSet } from '@fluentui/react/lib/OverflowSet';
import { DirectionalHint, TooltipHost } from '@fluentui/react';
import { CommandBarButton } from '@fluentui/react/lib/Button';
import { getTheme, mergeStyles } from '@fluentui/react/lib/Styling';
import { MarqueeSelection } from '@fluentui/react/lib/MarqueeSelection';

import "../../css/CustomButton.css"
import { isNullOrUndefined, isNullUndefinedOrEmpty } from "../../common/Helpers";

function base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64); // Comment this if not using base64
    const bytes = new Uint8Array(binaryString.length);
    return bytes.map((byte, i) => binaryString.charCodeAt(i));
}

export default function List(props) {
    const { t } = useTranslation();

    let moment = require('moment');

    const linkExport = useRef();

    const entityData = props.data;
    const setData = props.setData;
    const handleExport = props.handleExport;
    const enableExport = props.enableExport !== undefined && props.enableExport !== null ? props.enableExport : false;
    const aux_columns = props.columns;
    const aux_fieldsToExport = props.fieldsToExport;
    
    const exportFileName = props.exportFileName;

    const iconButtonStyles = { root: { float: 'left', height: 'inherit', padding: '10px' } };
    const onRenderItemStyles = { root: { padding: '10px' } };
    const onRenderOverflowButtonStyles = { root: { padding: '10px' }, menuIcon: { fontSize: '16px' } };

    const Download = (base64FFile, type) => {
        const arrayBuffer = base64ToArrayBuffer(base64FFile);
    
        const blob = new Blob([arrayBuffer], { type: type });
        const url = URL.createObjectURL(blob);
        const fileName = (t('data-lang-export-file-name') +"_"+ moment(new Date()).format("DD_MM_YYYY_HH_mm_ss")).replaceAll(" ", "_");
        linkExport.current.href = (url);
        linkExport.current.download = exportFileName !== null || exportFileName !== undefined ? exportFileName.replaceAll(" ", "_") : fileName;
        linkExport.current.click();
    }

    const _onColumnClick = (ev, column) => {
        const newColumns = _columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            }
            else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });

        setData(prevState => ({
            ...prevState,
            data: null,
            pageNumber: 1,
            orderAsc: currColumn.isSortedDescending,
            orderField: currColumn.fieldName
        }));

        setColumns(newColumns);
    }

    const renderDetailsHeader = (detailsHeaderProps) => {
        return (<DetailsHeader {...detailsHeaderProps} onRenderColumnHeaderTooltip={renderCustomHeaderTooltip} />);
    }
    const onRenderItem = (item) => {
        return (
          <TooltipHost content={item.title} directionalHint={DirectionalHint.rightCenter}>
            <CommandBarButton
              role="menuitem"
              aria-label={item.name}
              styles={onRenderItemStyles}
              iconProps={{ iconName: item.icon }}
              onClick={item.onClick}
            />
          </TooltipHost>
        );
    };
    const onRenderOverflowButton = (overflowItems) => {
        return (
          <TooltipHost content="More items" directionalHint={DirectionalHint.rightCenter}>
            <CommandBarButton
              role="menuitem"
              aria-label="More items"
              styles={onRenderOverflowButtonStyles}
              menuIconProps={{ iconName: 'More' }}
              menuProps={{ items: overflowItems }}
            />
          </TooltipHost>
        );
    };
    const renderCustomHeaderTooltip = (tooltipHostProps) => {
        const column = (tooltipHostProps).column;

        if (column === undefined || column.key === "id") {

            let filterActions = [];

            if (isNullUndefinedOrEmpty(entityData) || entityData.filters.length === 0) {
                filterActions = [
                    {
                        key: 'item1',
                        icon: "Filter",
                        name: t('data-lang-btn-filter'),
                        title: t('data-lang-btn-filter'),
                        onClick: () => handleFilter(),
                    }
                ];
            }
            else {
                filterActions = [
                    {
                        key: 'item1',
                        icon: "Filter",
                        name: t('data-lang-btn-filter'),
                        title: t('data-lang-btn-filter'),
                        onClick: () => handleFilter(),
                    },
                    {
                        key: 'item2',
                        icon: "RemoveFilter",
                        name: t('data-lang-btn-filterclear'),
                        title: t('data-lang-btn-filterclear'),
                        onClick: () => handleClearFilter(),
                    }
                ]
            }

            return (
                <div className="text-center">
                    <span>{tooltipHostProps.children}</span>
                    <Row style={{padding: 0, margin: 0}}>
                        <Col style={{padding: 0, margin: 0}}>
                            <OverflowSet
                                className="action-menu-list-toolbar d-flex justify-content-center"
                                role="menubar"      
                                items={filterActions}
                                onRenderOverflowButton={onRenderOverflowButton}
                                onRenderItem={onRenderItem}
                            />
                        </Col>
                        {enableExport && 
                            <Col style={{padding: 0, margin: 0}}>
                                <IconButton
                                    menuIconProps={{ iconName: 'MoreVertical' }}
                                    role="button"
                                    className="action-menu-list-toolbar"
                                    aria-haspopup
                                    styles={iconButtonStyles}
                                    menuProps={{
                                        items: [
                                            {
                                                key: 'export',
                                                iconProps: { iconName: 'ExcelLogo' },
                                                text: t('data-lang-btn-export'),
                                                className: "ms-Icon-custom",
                                                onClick: () => handleExport(Download, JSON.stringify((aux_fieldsToExport ? aux_fieldsToExport : aux_columns).map(col => col.fieldName + "[|]" + col.name))),
                                            },
                                        ],
                                    }}
                                />
                            </Col>
                        }

                    </Row>
                </div>
            );
        }
        else {

            const arr = !isNullUndefinedOrEmpty(entityData) ? entityData.filters : null;
            const filter = !isNullUndefinedOrEmpty(arr) ? arr.find(x => x.field === column.key) : null;
            const auxValue = !isNullOrUndefined(filter)? filter.value : "";

            return (
                <div className={tooltipHostProps.hostClassName}>
                    <Row>
                        <Col>
                            <span>{tooltipHostProps.children}</span>
                        </Col>
                    </Row>
                    {column.key.indexOf("nofilter_") !== 0 &&                    
                        <Row>
                            <Col>
                                <TextField
                                    placeholder={t('data-lang-btn-filter')}
                                    onChange={(event) => onFilterChange(event, column.key)}
                                    value={auxValue}
                                    name={column.key}
                                    ref={column.key} 
                                    autoComplete="off"
                                />
                            </Col>
                        </Row>
                    }
                </div>
            );
        }
    }

    const onPageChange = async (_pageNumber) => {
        setData(prevState => ({
            ...prevState,
            data: null,
            pageNumber: (_pageNumber + 1)
        }));
    }

    const onFilterChange = (event, field) => {
        let textFilter = event.currentTarget.value;
        let listFilters = entityData.filters;
        let elementFound = false;
        listFilters.forEach(element => {
            if(element.field === field) {
                elementFound = true;
                element.value = textFilter;
            }
        });

        if (elementFound === false) {
            listFilters.push({field: field, value: textFilter})
        }

        setData(prevState => ({
            ...prevState,
            /*data: null,*/
            pageNumber: 1,
            filters: listFilters
        }));
    }

    const handleFilter = async () => {
        setData(prevState => ({
            ...prevState,
            data: null
        }));
    }
    
    const handleClearFilter = async () => {
        setData(prevState => ({
            ...prevState,
            data: null,
            filters: []
        }));
    }
    

    const handleChangePageSize = async (control, option) => {
        const _pageSize = parseInt(option.key);

        setData(prevState => ({
            ...prevState,
            data: null,
            pageSize: _pageSize,
            pageNumber: 1
        }));
    }

    const [_columns, setColumns] = useState(aux_columns.map((item, index) => {
        if (item.onRender !== undefined) {
            return {
                key: item.key,
                name: item.name,
                fieldName: item.fieldName,
                minWidth: item.minWidth,
                maxWidth: item.maxWidth,
                isResizable: true,
                isSorted: true,
                isSortedDescending: false,
                onColumnClick: _onColumnClick,
                onRender: item.onRender
            }
        }
        else {
            return {  
                key: item.key,
                name: item.name,
                fieldName: item.fieldName,
                minWidth: item.minWidth,
                maxWidth: item.maxWidth,
                isResizable: true,
                isFiltered: false,
                isSorted: true,
                isSortedDescending: false,
                onColumnClick: _onColumnClick,
            }
        }
    }));
    let _draggedItem;
    let _draggedIndex = -1;
    const dragState = {
        isColumnReorderEnabled: true,
        frozenColumnCountFromStart: '1',
        frozenColumnCountFromEnd: '1',
    };
    const theme = getTheme();
    const dragEnterClass = mergeStyles({
        backgroundColor: theme.palette.neutralLight,
    });
    const _selection = new Selection();
    const _handleColumnReorder = (draggedIndex, targetIndex) => {
        const draggedItems = _columns[draggedIndex];
        const newColumns = [..._columns];
    
        // insert before the dropped item
        newColumns.splice(draggedIndex, 1);
        newColumns.splice(targetIndex, 0, draggedItems);

        setColumns(newColumns);
    };
    const _getColumnReorderOptions = () => {
        return {
          frozenColumnCountFromStart: parseInt(dragState.frozenColumnCountFromStart, 10),
          frozenColumnCountFromEnd: parseInt(dragState.frozenColumnCountFromEnd, 10),
          handleColumnReorder: _handleColumnReorder,
        };
    }
    const _insertBeforeItem = (item) => {
        const draggedItems = _selection.isIndexSelected(_draggedIndex)
          ? (_selection.getSelection())
          : [!_draggedItem];
    
        const insertIndex = entityData.data.indexOf(item);
        const items = entityData.data.filter(itm => draggedItems.indexOf(itm) === -1);
    
        items.splice(insertIndex, 0, ...draggedItems);
    
        setData(prevState => ({
            ...prevState,
            data: items,
        }));

    }
    const _getDragDropEvents = () => {
        return {
          canDrop: (dropContext, dragContext) => {
            return true;
          },
          canDrag: (item) => {
            return true;
          },
          onDragEnter: (item, event) => {
            // return string is the css classes that will be added to the entering element.
            return dragEnterClass;
          },
          onDragLeave: (item, event) => {
            return;
          },
          onDrop: (item, event) => {
            if (_draggedItem) {
              _insertBeforeItem(item);
            }
          },
          onDragStart: (item, itemIndex, selectedItems, event) => {
            _draggedItem = item;
            _draggedIndex = !itemIndex;
          },
          onDragEnd: (item, event) => {
            _draggedItem = undefined;
            _draggedIndex = -1;
          },
        };
    }
    const _dragDropEvents = _getDragDropEvents();

    return (
        <div id="listWithActions" className="col-12">
            <a style={{display: "none"}} ref={linkExport} href="/" >#</a>
            <ThemeProvider>
                <MarqueeSelection selection={_selection}>
                    <ShimmeredDetailsList
                        items={entityData.data || []}
                        setKey="set"
                        columns={_columns}
                        selection={_selection}
                        selectionMode={SelectionMode.none}
                        layoutMode={DetailsListLayoutMode.justified}
                        enableShimmer={!entityData.data}
                        constrainMode={ConstrainMode.unconstrained}
                        dragDropEvents={_dragDropEvents}
                        onRenderDetailsHeader={renderDetailsHeader}
                        columnReorderOptions={ dragState.isColumnReorderEnabled ? _getColumnReorderOptions() : undefined}
                        listProps={{
                            renderedWindowsAhead: 0,
                            renderedWindowsBehind: 0,
                        }}
                    />
                </MarqueeSelection>
                {(entityData && entityData.data) &&
                    <div className="float-start">
                        <Row>
                            <Col className="text-nowrap">
                                <Pagination
                                    selectedPageIndex={entityData.pageNumber - 1}
                                    pageCount={entityData.totalPages}
                                    itemsPerPage={entityData.pageSize}
                                    totalItemCount={entityData.totalRecords}
                                    onPageChange={onPageChange}
                                    //format="comboBox"
                                    firstPageIconProps={{ iconName: 'DoubleChevronLeft' }}
                                    previousPageIconProps={{ iconName: 'ChevronLeft' }}
                                    nextPageIconProps={{ iconName: 'ChevronRight' }}
                                    lastPageIconProps={{ iconName: 'DoubleChevronRight' }}
                                />
                            </Col>
                            <Col className="pt-1 ps-3 col">
                                <Row className="ps-4">
                                <Col className="ps-4 pt-1">
                                    {t('data-lang-lbl-rows')}
                                </Col>
                                <Col style={{position: "absolute", width: 200}} className="ps-4">
                                    <Dropdown className="ms-4 ps-3" 
                                        placeholder={entityData.pageSize}
                                        options={[
                                            { key: '1', text: '1' },
                                            { key: '2', text: '2' },
                                            { key: '5', text: '5' },
                                            { key: '10', text: '10' },
                                            { key: '25', text: '25' },
                                            { key: '50', text: '50' },
                                        ]}
                                        styles={{ dropdown: { width: 100 }}}
                                        onChange={handleChangePageSize}
                                    />
                                </Col> 
                                </Row>
                            </Col>
                        </Row>
                    </div>
                }
            </ThemeProvider>
        </div>
    ); 
}